export default "__VITE_ASSET__e01278eb__"